import React, { Component } from "react";
import { connect } from "react-redux";
import validator from "validator";

import { Modal, Button, TextArea, TextInput } from "../elements";

import { send } from "../../store/contacts/actions";

class ContactsModal extends Component {
  state = {
    lastName: "",
    firstName: "",
    email: "",
    emailConfirm: "",
    phone: "",
    message: "",
    privacy: false,
  };

  isValid() {
    return [
      !validator.isEmpty(this.state.lastName),
      !validator.isEmpty(this.state.firstName),
      !validator.isEmpty(this.state.email) &&
        validator.isEmail(this.state.email),
      !validator.isEmpty(this.state.emailConfirm) &&
        this.state.email === this.state.emailConfirm,
      this.state.privacy,
    ].every((isValid) => isValid);
  }

  renderContent() {
    return (
      <div className="uk-grid uk-grid-medium">
        <div className="uk-width-1-3@s">
          <div className="information">
            <p>
              Per contattarci compila il form o chiama il numero{" "}
              <strong>02.80.88.63.02</strong>.
            </p>
          </div>
        </div>
        <div className="uk-width-2-3@s">
          <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
            <div>
              <TextInput
                placeholder="cognome"
                value={this.state.lastName}
                onChange={(lastName) => this.setState({ lastName })}
              />
            </div>
            <div>
              <TextInput
                placeholder="nome"
                value={this.state.firstName}
                onChange={(firstName) => this.setState({ firstName })}
              />
            </div>
          </div>
          <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
            <div>
              <TextInput
                type="email"
                placeholder="e-mail"
                value={this.state.email}
                onChange={(email) => this.setState({ email })}
              />
              {this.state.email !== "" &&
                !validator.isEmail(this.state.email) && (
                  <p className="uk-text-danger uk-text-small uk-margin-small-top">
                    questo indirizzo e-mail non sembra valido...
                  </p>
                )}
            </div>
            <div>
              <TextInput
                type="email"
                placeholder="conferma e-mail"
                value={this.state.emailConfirm}
                onChange={(emailConfirm) => this.setState({ emailConfirm })}
              />
              {this.state.email !== "" &&
                this.state.email !== this.state.emailConfirm && (
                  <p className="uk-text-danger uk-text-small uk-margin-small-top">
                    le e-mail non coincidono...
                  </p>
                )}
            </div>
          </div>
          <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
            <div>
              <TextInput
                placeholder="telefono"
                value={this.state.phone}
                onChange={(phone) => this.setState({ phone })}
              />
            </div>
          </div>
          <div className="uk-grid uk-grid-small uk-child-width-1-1">
            <div>
              <TextArea
                placeholder="messaggio"
                value={this.state.message}
                onChange={(message) => this.setState({ message })}
                rows="5"
              />
            </div>
          </div>
          <div className="uk-grid uk-grid-medium">
            <div className="uk-width-1-1">
              <ul data-uk-accordion>
                <li>
                  <a className="uk-accordion-title" href="#">
                    Informativa sulla privacy
                  </a>
                  <div className="uk-accordion-content">
                    <p className="uk-text-small">
                      La informiamo, ai sensi dell'art. 13 del D. Lgs. 196/2003
                      ("Codice in materia di protezione dei dati personali"),
                      che i dati da Lei forniti saranno raccolti su supporti
                      informatici, elettronici e/o cartacei e trattati con
                      modalità idonee a garantire la sicurezza e la riservatezza
                      nel rispetto delle disposizioni del Codice. La informiamo
                      che i dati fornitici verranno utilizzati per finalità
                      istituzionali strettamente connesse alle attività svolte
                      dalla Società Youcan S.r.l. S.s.d.. I dati personali
                      acquisiti non saranno comunicati a terzi, fatta eccezione
                      per tutti i casi in cui si rendesse necessario al fine
                      dello svolgimento delle attività istituzionali o
                      funzionali all'erogazione dei servizi forniti dalla
                      Società Youcan S.r.l S.s.d.. In ogni momento, in qualità
                      di Interessato, Lei potrà esercitare i diritti citati
                      all'art. 7 del D. Lgs. 196/2003.
                    </p>
                  </div>
                </li>
              </ul>
              <input
                type="checkbox"
                checked={this.state.privacy}
                onChange={() => this.setState({ privacy: !this.state.privacy })}
              />{" "}
              Accetto
            </div>
          </div>
          <div className="actions uk-text-center">
            <Button
              disabled={!this.isValid()}
              onClick={() => this.props.send(this.state)}
            >
              Invia
            </Button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error, success } = this.props;

    let content = null;
    if (!loading) {
      if (error) {
        content = (
          <div className="uk-alert uk-alert-danger uk-padding uk-text-center">
            <p>
              <strong>Errore</strong>
              <br />
              Si è verificato un errore nell'invio della tua richiesta.
              <br />
              Prova nuovamente più tardi o scrivici all'indirizzo
              info@youcanfitnessfactory.it.
            </p>
          </div>
        );
      } else {
        if (success) {
          content = (
            <div className="uk-alert uk-alert-success uk-padding uk-text-center">
              <p>
                <strong>Richiesta inviata</strong>
                <br />
                La tua richiesta è stata inviata correttamente. Verrai
                ricontattato al più presto da un responsabile.
              </p>
              <p>
                <i className="fa fa-spinner fa-spin fa-3x" />
              </p>
            </div>
          );
        } else {
          content = this.renderContent();
        }
      }
    } else {
      content = (
        <div className="uk-padding-large uk-text-center">
          <i className="fa fa-spinner fa-spin fa-3x" />
        </div>
      );
    }

    return (
      <Modal className="contacts-modal" name="contacts-modal">
        <h2>Contattaci</h2>
        {content}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => state.contacts;
const mapDispatchToProps = (dispatch) => ({
  send: (info) => dispatch(send(info)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactsModal);



// WEBPACK FOOTER //
// ./src/ui/components/ContactsModal.js